var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeMobileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1109,
    height: 1300,
    viewBox: "0 0 1109 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_36)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1109,
    height: 1300,
    fill: "url(#paint0_radial_655_36)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1109,
    height: 1300,
    fill: "url(#paint1_radial_655_36)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1109,
    height: 1300,
    fill: "url(#paint2_radial_655_36)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.4 656.9C271.3 628.4 230.8 628.4 223.6 656.9L221.6 665.3C220.3 670.1 217.8 674.6 214.3 678.2C210.8 681.8 206.3 684.4 201.5 685.7C196.6 687 191.5 686.9 186.7 685.6C181.8 684.2 177.4 681.6 173.9 678L167.9 671.8C147.5 650.7 112.4 670.9 120.5 699.2L122.9 707.5C124.2 712.3 124.3 717.4 123 722.3C121.8 727.2 119.2 731.6 115.7 735.2C112.1 738.7 107.7 741.3 102.8 742.5C98 743.8 92.8 743.7 88 742.4L79.7 740C51.5 731.9 31.2 767 52.3 787.4L58.5 793.4C62.1 796.9 64.8 801.3 66.1 806.1C67.5 811 67.5 816.1 66.2 821C64.9 825.8 62.3 830.3 58.7 833.8C55.1 837.3 50.7 839.8 45.8 841L37.4 843.1C8.9 850.3 8.9 890.7 37.4 897.9L45.8 900C50.7 901.2 55.1 903.7 58.7 907.2C62.3 910.7 64.9 915.2 66.2 920C67.5 924.9 67.5 930 66.1 934.9C64.8 939.7 62.1 944.1 58.5 947.6L52.3 953.6C31.2 974 51.4 1009.1 79.7 1001L88 998.7C92.8 997.3 98 997.2 102.8 998.5C107.7 999.7 112.2 1002.3 115.7 1005.8C119.3 1009.4 121.8 1013.8 123.1 1018.7C124.3 1023.6 124.3 1028.7 122.9 1033.5L120.5 1041.8C112.4 1070 147.5 1090.3 167.9 1069.2L173.9 1063C177.4 1059.4 181.8 1056.8 186.7 1055.4C191.5 1054.1 196.6 1054 201.5 1055.3C206.3 1056.6 210.8 1059.2 214.3 1062.8C217.8 1066.4 220.3 1070.9 221.6 1075.7L223.6 1084.1C230.8 1112.6 271.2 1112.6 278.4 1084.1L280.5 1075.7C281.7 1070.9 284.2 1066.4 287.7 1062.8C291.3 1059.2 295.7 1056.6 300.5 1055.3C305.4 1054 310.5 1054.1 315.4 1055.4C320.2 1056.8 324.6 1059.4 328.1 1063L334.1 1069.2C354.6 1090.3 389.6 1070.1 381.5 1041.8L379.2 1033.5C377.8 1028.7 377.7 1023.5 379 1018.7C380.3 1013.8 382.8 1009.4 386.4 1005.8C389.9 1002.2 394.4 999.7 399.2 998.4C404.1 997.2 409.2 997.2 414 998.6L422.4 1001C450.6 1009.1 470.8 974 449.7 953.6L443.5 947.6C439.9 944.1 437.3 939.7 435.9 934.9C434.6 930 434.6 924.9 435.9 920C437.2 915.2 439.7 910.7 443.3 907.2C446.9 903.7 451.4 901.2 456.3 900L464.7 897.9C493.2 890.7 493.2 850.3 464.7 843.1L456.3 841C451.4 839.8 446.9 837.3 443.3 833.8C439.7 830.3 437.2 825.8 435.9 821C434.6 816.1 434.6 811 435.9 806.1C437.3 801.3 439.9 796.9 443.5 793.4L449.7 787.4C470.8 767 450.6 731.9 422.4 740L414 742.3C409.2 743.7 404.1 743.8 399.2 742.5C394.3 741.3 389.9 738.7 386.3 735.2C382.8 731.6 380.2 727.2 379 722.3C377.7 717.4 377.8 712.3 379.1 707.5L381.5 699.2C389.6 671 354.6 650.7 334.1 671.8L328.1 678C324.6 681.6 320.2 684.2 315.4 685.6C310.5 686.9 305.4 687 300.5 685.7C295.7 684.4 291.3 681.8 287.7 678.2C284.2 674.6 281.7 670.1 280.5 665.3L278.4 656.9ZM251 1017.3C270.5 1017.6 289.8 1014 307.8 1006.7C325.9 999.5 342.3 988.7 356.2 975C370 961.4 381 945.1 388.5 927.1C396 909.2 399.9 889.9 399.9 870.5C399.9 851 396 831.8 388.5 813.8C381 795.9 370 779.6 356.2 765.9C342.3 752.3 325.9 741.5 307.8 734.3C289.8 727 270.5 723.4 251 723.7C212.1 723.7 174.7 739.2 147.2 766.7C119.7 794.2 104.2 831.6 104.2 870.5C104.2 909.4 119.7 946.8 147.2 974.3C174.7 1001.9 212.1 1017.3 251 1017.3V1017.3Z",
    fill: "#3BB59D",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_655_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.4 448.2C888.6 435.6 906.2 431.8 929.8 430.7C958 430.9 984 417.9 1002.3 397.8C1024.8 373.2 1036.5 340.7 1035 307.5C1033.5 274.2 1018.8 242.9 994.2 220.5C969.7 198 937.2 186.3 903.9 187.8C870.7 189.3 839.4 204 816.9 228.6C802.8 244 789 265.4 790.8 303.8C791.7 324.5 789.7 345.3 778.7 363.6",
    stroke: "#451DAB",
    strokeOpacity: 0.5,
    strokeWidth: 41.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.6 425L815.3 509.6",
    stroke: "#451DAB",
    strokeOpacity: 0.5,
    strokeWidth: 41.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.1 500.5L743.9 556.9",
    stroke: "#451DAB",
    strokeOpacity: 0.5,
    strokeWidth: 41.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_655_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160 362.2C168.8 370.8 179.8 376.3 191.3 378C202.8 379.6 214.2 377.3 223.7 371.4L281.4 335.3C298.4 324.7 319 321.1 339.6 325C360.1 329 379.3 340.3 393.8 357C405.8 354.4 418.6 356.4 430.1 362.8C441.5 369.1 450.8 379.3 456.2 391.6C461.6 403.8 462.8 417.3 459.5 429.6C456.3 441.8 448.9 452.1 438.6 458.6C428.5 464.9 416.4 467.1 404.2 464.9C392 462.6 380.5 456.1 371.8 446.3C363.1 436.6 357.7 424.2 356.4 411.5C355.2 398.7 358.3 386.2 365.1 376.3C356.3 367.8 345.2 362.2 333.7 360.6C322.2 358.9 310.8 361.3 301.3 367.2L243.6 403.2C228 413 209.3 416.9 190.4 414.3L221.9 464.8C233.9 462.6 246.6 464.9 257.9 471.4C269.1 477.9 278.1 488.1 283.3 500.3C288.5 512.5 289.6 525.9 286.3 538C283.1 550.2 275.7 560.3 265.5 566.7C255.2 573.1 242.9 575.3 230.5 572.9C218.2 570.5 206.6 563.7 198 553.6C189.3 543.6 184.1 531 183.2 518C182.2 505.1 185.7 492.6 193 482.8L130 381.8C118.1 384.1 105.4 381.8 94.2 375.4C83 369 74 358.9 68.7 346.8C63.4 334.8 62.2 321.5 65.3 309.4C68.4 297.3 75.6 287 85.6 280.5C95.6 273.9 107.8 271.5 120.1 273.6C132.4 275.6 144 282.1 152.8 291.8C161.7 301.6 167.2 314 168.5 326.8C169.8 339.7 166.8 352.2 160 362.2V362.2ZM126.2 343.7C130 341.3 132.7 337.3 133.5 332.7C134.3 328 133.3 323 130.7 318.7C128 314.5 124 311.4 119.4 310.1C114.9 308.8 110.1 309.4 106.3 311.8C102.5 314.2 99.9 318.2 99 322.9C98.2 327.5 99.2 332.5 101.8 336.8C104.5 341 108.5 344.1 113.1 345.4C117.7 346.7 122.4 346.1 126.2 343.7ZM245.6 534.8C249.4 532.5 252 528.5 252.8 523.8C253.7 519.1 252.7 514.1 250 509.9C247.4 505.7 243.4 502.6 238.8 501.3C234.2 500 229.5 500.6 225.7 503C221.8 505.4 219.2 509.3 218.4 514C217.5 518.7 218.5 523.7 221.2 527.9C223.8 532.1 227.9 535.2 232.4 536.5C237 537.8 241.7 537.2 245.6 534.8ZM418.7 426.7C422.5 424.3 425.2 420.4 426 415.7C426.9 411 425.8 406 423.2 401.8C420.6 397.6 416.5 394.5 411.9 393.2C407.4 391.9 402.7 392.5 398.8 394.9C395 397.2 392.4 401.2 391.5 405.9C390.7 410.6 391.7 415.6 394.3 419.8C397 424 401 427.1 405.6 428.4C410.2 429.7 414.9 429.1 418.7 426.7Z",
    fill: "#449CB9",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_655_36",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.8 371.2) rotate(-90) scale(2462.79 1112.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B5CF6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_655_36",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(887.2 742.4) rotate(-90) scale(2258.49 1019.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449CB9",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_655_36",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(554.5 1484.8) rotate(-90) scale(1926.84 870.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB59D",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1109,
    height: 1300,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_655_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 502,
    fill: "white",
    transform: "translate(837.399 20) rotate(42.3844)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_655_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408.294,
    height: 450.711,
    fill: "white",
    transform: "translate(-30 286.246) rotate(-31.9806)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMobileBg);
export default __webpack_public_path__ + "static/media/home-mobile-bg.7a984b9892db4dcf1ad05fcfae9c0c09.svg";
export { ForwardRef as ReactComponent };